// ============================================================================
// INTERPOLATION SEARCH - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'interpolation-search',
  name: 'Interpolation Search',
  category: 'Search',
  complexity: {
    time: 'O(log log n) average, O(n) worst',
    space: 'O(1)'
  },
  description: 'Interpolation Search estimates the position of the target using interpolation formula, making it efficient for uniformly distributed sorted arrays.'
};
export type MetaType = typeof meta;
